module.exports = __webpack_public_path__ + "img/Grimassen.57968cba.svg";